import { map, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { SecondaryHeading } from 'components/Headings';
import HorizontalRule from 'components/HorizontalRule';
import Paragraph from 'components/Paragraph';
import Theme from 'styles/theme';

const PdpDifferentiators = ({ heading, cards, className, dataTestId }) => {
  return (
    <section
      className={`PdpDifferentiators ${className}`}
      {...(dataTestId && { 'data-testid': dataTestId })}
    >
      <SecondaryHeading>{heading}</SecondaryHeading>
      {map(cards, card => (
        <React.Fragment key={get(card, 'heading')}>
          <HorizontalRule />
          <Paragraph className="PdpDifferentiators__card">{get(card, 'heading')}</Paragraph>
        </React.Fragment>
      ))}
      <style jsx global>
        {`
          .PdpDifferentiators {
            text-align: center;
            background-color: ${Theme.get('colors-grey')};
            border-radius: ${Theme.get('border-radius-px')};
          }
        `}
      </style>
      <style jsx global>
        {`
          .PdpDifferentiators .typography--secondary-heading {
            padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 4}px;
            font-size: 18px;
            line-height: 1.33;
          }

          .PdpDifferentiators .Paragraph {
            padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 4}px;
            font-size: ${Theme.get('font-size-description-px')};
            margin: 0;
          }

          .PdpDifferentiators .HorizontalRule {
            margin: 0;
            background-color: ${Theme.get('colors-black-20')};
          }
        `}
      </style>
    </section>
  );
};

PdpDifferentiators.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  heading: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape({ heading: PropTypes.string.isRequired })).isRequired,
};

export default PdpDifferentiators;
